// extracted by mini-css-extract-plugin
export default {"-large":"PvrGFipsFMWLV8mXNgB9","background":"WAFEQ5eLREWaGDxYBvVI"};